import {STATE_PROP_NAME} from './factor-details-modal-constants'

export const getFactorDetailsModal = state => state[STATE_PROP_NAME]
